import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { getActionLogs } from './actionCreators';
import { initialState, LOGS_SLICE_NAME, LogsState } from './models';

export const slice = createSlice({
  name: LOGS_SLICE_NAME,
  initialState,
  reducers: {
    resetLogsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActionLogs.fulfilled, (state: LogsState, action) => {
        const { payload, meta } = action;
        state.actionLogs = payload.items;
        state.pagination = { ...payload.cursor, limit: meta.arg.limit };
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(getActionLogs), (state: LogsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getActionLogs), (state: LogsState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;

export const { resetLogsState } = slice.actions;
